import { useTypedSelector } from 'hooks/use-typed-selector';
import { User } from 'common/interfaces';
import { PAGES } from 'common/enums';

const useIsPageAvailable = (page: PAGES) => {
  const user = useTypedSelector<User>(state => state['app'].user);

  return user.appPages.some(appPage => appPage.url === page);
};

export default useIsPageAvailable;
